// TODO: Merge this implementation with TagManagerProvider component.
import TagManager from 'react-gtm-module'

import type { Event } from './events'

type Trigger = <TName extends Event['name']>(
  name: TName,
  parameters: Extract<Event, { name: TName }>['parameters'],
) => void

export const useTagManager = () => {
  const trigger: Trigger = (name, parameters) => {
    TagManager.dataLayer({ dataLayer: { event: name, ...parameters } })
  }

  return { trigger }
}
